import OptionChainToolUseCase from "@domains/features/Search/useCases/OptionChainToolsUseCase";
import GeneralSearchUseCase from "@domains/features/Search/useCases/GenSearchUseCase";
import TrendingSearchUseCase from "@domains/features/Search/useCases/TrendingSearchUseCase";
import EquitySearchUseCase from "@domains/features/Search/useCases/EqSearchUseCase";
import FutureSearchUseCase from "@domains/features/Search/useCases/FuSearchUseCase";
import OptionSearchUseCase from "@domains/features/Search/useCases/OpSearchUseCase";
import IndicesSearchUseCase from "@domains/features/Search/useCases/IndicesSearchUseCase";
import MFSearchUseCase from "@domains/features/Search/useCases/MFSearchUseCase";
import CommSearchUseCase from "@domains/features/Search/useCases/CommSearchUseCase";
import NCDSearchUseCase from "@domains/features/Search/useCases/NCDSearchUseCase";
import ETFSSearchUseCase from "@domains/features/Search/useCases/ETFSSearchUseCase";
import CurSearchUseCase from "@domains/features/Search/useCases/CurSearchUseCase";
import PrimaryMarketSearchUseCase from "@domains/features/Search/useCases/PMSearchUseCase";
import CommFutSearchUseCase from "@domains/features/Search/useCases/ComFutSearchUseCase";
import CommOptSearchUseCase from "@domains/features/Search/useCases/ComOptSearchUseCase";
import SaveTrendingUseCase from "@domains/features/Search/useCases/saveTrendingUseCase";
import { SearchAssetTypeEnum } from "../constant";
export default (repositories) => {
    return {
        search: {
            optionChainTool: new OptionChainToolUseCase(repositories.search),
            genSearch: new GeneralSearchUseCase(repositories.search),
            trendingSearch: new TrendingSearchUseCase(repositories.search),
            assetSearch: {
                [SearchAssetTypeEnum.Equity]: new EquitySearchUseCase(repositories.search),
                [SearchAssetTypeEnum.Future]: new FutureSearchUseCase(repositories.search),
                [SearchAssetTypeEnum.Option]: new OptionSearchUseCase(repositories.search),
                [SearchAssetTypeEnum.Indices]: new IndicesSearchUseCase(repositories.search),
                [SearchAssetTypeEnum.MF]: new MFSearchUseCase(repositories.search),
                [SearchAssetTypeEnum.Commodity]: new CommSearchUseCase(repositories.search),
                [SearchAssetTypeEnum.NcdSecondary]: new NCDSearchUseCase(repositories.search),
                // [SearchAssetTypeEnum.SGB]: new SGBSearchUseCase(repositories.search),
                [SearchAssetTypeEnum.ETFs]: new ETFSSearchUseCase(repositories.search),
                // [SearchAssetTypeEnum.CORPFD]: new CorpFDSearchUseCase(
                //   repositories.search
                // ),
                [SearchAssetTypeEnum.Currency]: new CurSearchUseCase(repositories.search),
                [SearchAssetTypeEnum.OptionChain]: undefined,
                [SearchAssetTypeEnum.PrimaryMarket]: new PrimaryMarketSearchUseCase(repositories.search),
                [SearchAssetTypeEnum.ComFut]: new CommFutSearchUseCase(repositories.search),
                [SearchAssetTypeEnum.ComOpt]: new CommOptSearchUseCase(repositories.search),
            },
            saveTrendingSearch: new SaveTrendingUseCase(repositories.search),
        },
    };
};
